export function LinkedText({ text }: { text: string }) {
  return tokenize(text).map((token, index) => {
    switch (token.type) {
      case 'text':
        return token.value
      case 'link':
        return (
          <a
            key={index}
            href={token.value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline break-words"
          >
            {token.value}
          </a>
        )
    }
  })
}

type Token = { type: 'text'; value: string } | { type: 'link'; value: string }

function tokenize(text: string): Token[] {
  return text.split(/(https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)])/gi).map((value, index): Token => {
    if (index % 2 == 0) return { type: 'text', value }
    return { type: 'link', value }
  })
}
